type ConsoleType = typeof console;

export default function GlobalDebug(debugOn: boolean, suppressAll?: boolean) {
  const savedConsole: ConsoleType = console;
  const suppress = suppressAll || false;

  if (!debugOn) {
    // Suppress the default console functionality
    // eslint-disable-next-line no-global-assign
    console = {} as ConsoleType;
    console.log = () => {};

    // Suppress all types of consoles
    if (suppress) {
      console.info = () => {};
      console.warn = () => {};
      console.error = () => {};
    } else {
      console.info = savedConsole.info.bind(savedConsole);
      console.warn = savedConsole.warn.bind(savedConsole);
      console.error = savedConsole.error.bind(savedConsole);
    }
  } else {
    // eslint-disable-next-line no-global-assign
    console = savedConsole;
  }
}
